export const MAX_IMPORT_BYTES = 5 * 1024 * 1024

/** Why a file cannot be imported as a budget (an i18n key), or null. The server checks the same. */
export function importFileProblem(name: string, size: number): string | null {
  if (!/\.(xlsx|csv)$/i.test(name)) return 'CostControl_import_wrong_type'
  if (size > MAX_IMPORT_BYTES) return 'CostControl_import_too_large'
  return null
}

/** What DocumentSelectorModal hands back (only the fields the import reads). */
export interface PickedDocument {
  id: string
  name: string
  currentRevisionId?: string | null
  currentRevision?: { id: string; version: number; file?: { filename: string; size: number } | null } | null
}

/**
 * Ruling Q10: the import takes exactly one spreadsheet and its current revision, whose id both the dry run and the
 * apply send. The picker runs in single-select mode, so the count check only guards a misused picker; the revision and
 * file checks are the ones a user can actually hit (a PDF, an oversized sheet).
 */
export function importDocumentPick(docs: PickedDocument[]): { ok: true; revisionId: string; name: string; version: number | null } | { ok: false; problem: string } {
  if (docs.length !== 1) return { ok: false, problem: 'CostControl_import_pick_one' }
  const doc = docs[0]
  const revisionId = doc.currentRevision?.id ?? doc.currentRevisionId ?? null
  if (!revisionId) return { ok: false, problem: 'CostControl_import_pick_one' }
  const problem = importFileProblem(doc.currentRevision?.file?.filename ?? doc.name, doc.currentRevision?.file?.size ?? 0)
  if (problem) return { ok: false, problem }
  return { ok: true, revisionId, name: doc.name, version: doc.currentRevision?.version ?? null }
}
